module.exports = __webpack_public_path__ + "static/media/guide_Page_19.4005c4b3.png";